var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCkExtraLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CK_Extra-Logo_Horizontal_Positive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 328,
    height: 53.459,
    viewBox: "0 0 328 53.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M326.89,18.194V13.642c-5.195.145-9.173,3.466-11.242,7.99V13.57h-4.4l-.019,29.254h4.418V31.4c0-7.7,4.184-12.1,9.669-12.976,0,0,.618-.09,1.572-.217Z",
    transform: "translate(-19.913 -1.291)",
    fill: "#ed8b00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M345.528,16.8c-2.125-2.054-5.392-3.158-9.585-3.158h-4.5v4.108c1.413-.136,2.864-.235,4.044-.235,5.569,0,8.78,2.66,8.78,7.764v.887a31.961,31.961,0,0,0-9.061-1.222c-7.516,0-12.674,3.212-12.674,9.374v.109c0,5.882,5.5,8.931,11.073,8.931a13.162,13.162,0,0,0,10.671-4.877V42.75h4.362V25.222c0-3.656-1.03-6.434-3.1-8.433Zm-1.207,15.419c0,4.551-4.418,7.709-9.866,7.709-4.016,0-7.46-2.108-7.46-5.71v-.109c0-3.438,3.154-5.764,8.658-5.764a31.179,31.179,0,0,1,8.658,1.222v2.66Z",
    transform: "translate(-20.636 -1.298)",
    fill: "#ed8b00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M249.284,39.715a12.539,12.539,0,0,0,9.407-4.072l2.771,2.4a15.61,15.61,0,0,1-12.29,5.411A14.593,14.593,0,0,1,234.28,28.386c0-8.37,6.056-15.066,14.312-15.066,8.827,0,13.909,6.8,13.909,15.283,0,.389,0,.832-.056,1.5H238.782a10.287,10.287,0,0,0,10.5,9.592ZM258,26.658c-.515-5.248-3.632-9.709-9.519-9.709-5.139,0-9.061,4.126-9.7,9.709Z",
    transform: "translate(-14.989 -1.267)",
    fill: "#ed8b00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    d: "M293.6,34.152V3.92h4.493v8.8h9.566v3.837h-9.566v17.03c0,3.556,2.041,4.85,5.073,4.85a9.689,9.689,0,0,0,4.371-1.013v3.719a11.637,11.637,0,0,1-5.429,1.24c-4.839,0-8.518-2.316-8.518-8.234Z",
    transform: "translate(-18.784 -0.373)",
    fill: "#ed8b00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    d: "M278.626,27.852,290,13.718l.168-.208h-5.354L275.949,24.7l-8.817-11.148-.038-.045h-5.476L273.1,27.961,261.15,42.918H266.5L275.836,31.1l9.229,11.772.037.045h5.522Z",
    transform: "translate(-16.708 -1.285)",
    fill: "#ed8b00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5114",
    "data-name": "Rectangle 5114",
    width: 7.853,
    height: 29.49,
    transform: "translate(31.956 11.989)",
    fill: "#da291c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M114.695,36.025h10.558V42.74H106.72V13.25h7.975Z",
    transform: "translate(-6.828 -1.261)",
    fill: "#da291c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    d: "M129.24,13.25H149.3v6.705H137.093v4.886h11.663v6.2H137.093v4.986h12.243V42.74h-20.1Z",
    transform: "translate(-8.269 -1.261)",
    fill: "#da291c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    d: "M199.4,26.169l10.83-14.179h-11.12L189.081,25.572V11.989h-9.725v29.49h9.725V27.9l17.3,21.563a28.806,28.806,0,0,1-14.92,4c-15.706,0-27.669-11.546-27.669-26.748S175.752,0,191.459,0s27.659,11.546,27.659,26.73A26.452,26.452,0,0,1,213.436,43.3l-14.05-17.12Z",
    transform: "translate(-10.479)",
    fill: "#da291c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M63.913,31.5A8.887,8.887,0,0,0,69.566,23c0-6.479-4.783-9.754-13.357-9.754H46.4V42.74h7.853V30.388L62.415,42.74h9.267L63.913,31.492Zm-7.46-3.095h-2.2V19.512H56.5c3.192,0,5.27,1.348,5.27,4.352s-2.218,4.542-5.326,4.542Z",
    transform: "translate(-2.969 -1.261)",
    fill: "#da291c"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M16.193,19.647a8.12,8.12,0,0,0-8.284,8.289,8.12,8.12,0,0,0,8.284,8.289,8.705,8.705,0,0,0,7.423-4.117l6.065,3.828a15.788,15.788,0,0,1-13.647,7.275C6.8,43.209,0,36.54,0,27.935S6.8,12.67,16.034,12.67A15.677,15.677,0,0,1,29.765,19.9L23.55,23.836a8.431,8.431,0,0,0-7.357-4.19Z",
    transform: "translate(0 -1.205)",
    fill: "#da291c"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M89.013,19.647a8.12,8.12,0,0,0-8.284,8.289,8.12,8.12,0,0,0,8.284,8.289,8.705,8.705,0,0,0,7.423-4.117l6.065,3.828a15.811,15.811,0,0,1-13.647,7.275c-9.229,0-16.034-6.669-16.034-15.274s6.8-15.265,16.034-15.265a15.677,15.677,0,0,1,13.731,7.23L96.38,23.836a8.431,8.431,0,0,0-7.357-4.19Z",
    transform: "translate(-4.659 -1.205)",
    fill: "#da291c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkExtraLogo);
export default __webpack_public_path__ + "static/media/ck_extra_logo.19f070e9583ca4bba394889022d92525.svg";
export { ForwardRef as ReactComponent };